import { render } from "./CallToActionOrderNew.vue?vue&type=template&id=d1673b3a&scoped=true"
import script from "./CallToActionOrderNew.vue?vue&type=script&lang=js"
export * from "./CallToActionOrderNew.vue?vue&type=script&lang=js"

import "./CallToActionOrderNew.vue?vue&type=style&index=0&id=d1673b3a&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1673b3a"]])

export default __exports__